import { render, staticRenderFns } from "./1_m_franchise.vue?vue&type=template&id=6f8ec30e&scoped=true&"
import script from "./1_m_franchise.vue?vue&type=script&lang=js&"
export * from "./1_m_franchise.vue?vue&type=script&lang=js&"
import style0 from "./1_m_franchise.vue?vue&type=style&index=0&id=6f8ec30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8ec30e",
  null
  
)

export default component.exports